var render = function render(_c,_vm){return (_vm.props.count && _vm.props.count > 0)?_c('b-badge',_vm._b({class:['counter', _vm.data.class, _vm.data.staticClass],style:(_vm.data.style),attrs:{"id":_vm.data.id,"variant":_vm.props.variant}},'b-badge',_vm.data.attrs,false),[(Number(_vm.props.count) <= Number(_vm.props.maxCount))?[_vm._v(_vm._s(_vm.props.count))]:[_vm._v(_vm._s(_vm.props.maxCount)+"+")]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }